import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useKeycloak } from '@eggplant/context'
import type { Principal } from '@eggplant/types'

interface Props {
  onGetUsersSuccess: (response: Principal[]) => void
  onGetGroupsSuccess: (response: Principal[]) => void
}

const GetAvailableUsersGroupsRequest = ({
  onGetUsersSuccess,
  onGetGroupsSuccess
}: Props) => {
  const { keycloak: keycloakInstance } = useKeycloak()
  const url = `${keycloakInstance.authServerUrl}realms/${keycloakInstance.realm}/dai/v1`

  return (
    <>
      <AuthenticatedDataRequest
        method='get'
        onSuccess={onGetUsersSuccess}
        url={url + '/users'}
      />
      <AuthenticatedDataRequest
        method='get'
        onSuccess={onGetGroupsSuccess}
        url={url + '/groups'}
      />
    </>
  )
}

export default GetAvailableUsersGroupsRequest
